import { map } from "rxjs/operators";
import { GET, POST, PUT } from "../../../../module/services/fetch";
import { IAccountOpModel, UserManagementConfigButton } from "./constants";
import { Observable } from "rxjs";
import { SortingRule } from "react-table";

export const fetchUsersAccountRequest = (id: string) =>
  GET(`admin/user/${id}/accounts`).pipe(map((response: any) => response));

export const fetchRestorePassword = (body: IAccountOpModel) => {
  const { accountId, identitySystemId, userCode } = body;
  return POST(
    `admin/account/${accountId}/restore?identitySystemId=${identitySystemId}&userCode=${userCode}`
  ).pipe(map((response: any) => response));
};

export const fetchBlockAccount = (body: IAccountOpModel) => {
  if (body) {
    const { accountId, identitySystemId, userCode } = body;
    return POST(
      `admin/account/${accountId}/suspend?identitySystemId=${identitySystemId}&userCode=${userCode}`
    ).pipe(map((response: any) => response));
  }
  return new Observable<string>();
};

export const fetchResetPassword = (body: IAccountOpModel) => {
  const { accountId, identitySystemId, userCode } = body;
  return POST(
    `admin/user/resetPassword?accountId=${accountId}&identitySystemId=${identitySystemId}&userCode=${userCode}`
  ).pipe(map((response: any) => response));
};

export const postChangePassword = (request: IAccountOpModel) => {
  const { userCode, ...body } = request;

  return POST(`admin/user/changePassword?userCode=${userCode}`, body).pipe(
    map((response: any) => response)
  );
};

export const postUpdatePropagation = (data: IAccountOpModel[]) => {
  return POST("admin/user/resetPassword", data).pipe(map((res: any) => res));
};

export const fetchUserList = (payload: any) => {
  const { tmpUserBody, sortBy } = payload;
  return POST(
    `admin/users/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    tmpUserBody
  ).pipe(map((response: any) => response));
};

export const fetchEntitlementRequest = (
  selectedUser: any[],
  fetchBusinessRole: boolean = true
) =>
  POST(`entitlements/searchByUserId?businessRole=true`, selectedUser).pipe(
    map((response: any) => response)
  );

export const fetchOfficeRequest = () =>
  GET("user/ou").pipe(map((response: any) => response));

export const fetchUserRequest = (id: string | number) =>
  GET(`user/managedUser?ou=${id}`).pipe(map((response: any) => response));

export const fetchOfficeEntitlementRequest = (
  organizational_unit_code: string | number
) =>
  GET(`entitlements?ou=${organizational_unit_code}`).pipe(
    map((response: any) => response)
  );

export const fetchCreateRequest = (abilitationObj: FormData) =>
  POST(
    "admin/request/createRequests",
    abilitationObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const fetchBAOEntitlementRequest = (
  organizational_unit_code: string | number
) =>
  GET(`entitlements/businessRole?ou=${organizational_unit_code}`).pipe(
    map((response: any) => response)
  );

export const fetchPasswordPolicyUsersMgmt = (body: {
  accountId: string;
  identitySystemId: string;
}) => {
  const { accountId, identitySystemId } = body;
  return GET(
    `user/account/passwordPolicy?accountId=${accountId}&identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const fetchUsersManagersService = (userCode: string) =>
  GET(`user/${userCode}/secondary-managers`).pipe(
    map((response: any) => response)
  );

export const fetchUsersOusServices = (userCode: string) =>
  GET(`user/${userCode}/secondary-ou`).pipe(map((response: any) => response));

export const getPaginatedEntitlementRequestService = (payload: {
  body: {
    userCodes: string[];
    ou?: string;
    entitlementName?: string;
    entitlementDescription?: string;
    applicationName?: string;
    applicationDescription?: string;
    pageNumber: number;
    pageSize: number;
  };
  sortBy: SortingRule<{}>[];
}) => {
  const { body, sortBy } = payload;
  return POST(
    `entitlements/userCodes/commonOus${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const getPaginatedBusinessRoleRequestService = (payload: {
  body: {
    userCodes: string[];
    ou?: string;
    application?: string;
    applicationDescription?: string;
    pageNumber: number;
    pageSize: number;
  };
  sortBy: SortingRule<{}>[];
}) => {
  const { body, sortBy } = payload;
  return POST(
    `entitlements/commonBusinessRolesByUsers${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const adminUpdateMobileService = (body: {
  mobile: string;
  userCode: string;
}) => {
  const { mobile, userCode } = body;
  const encodedMobileNumber = encodeURIComponent(mobile);
  return PUT(
    `admin/update-mobile-number?userCode=${userCode}&mobileNumber=${encodedMobileNumber}`
  ).pipe(map((response: any) => response));
};

export const userManagementGetRolesService = () =>
  GET("authentication/admin/view-manage-users-roles").pipe(
    map((response: any) => response)
  );

export const userManagementGetConfigsService = () =>
  GET("authentication/admin/users/getConfig").pipe(
    map((response: any) => response)
  );

export const userManagementGetButtonsByRolesService = (role: string) =>
  GET(`authentication/admin/userMgmtButtons/${role}`).pipe(
    map((response: any) => response)
  );

export const userManagementUpdateConfigsService = (
  body: UserManagementConfigButton
) =>
  POST(`authentication/admin/buttons/management`, body).pipe(
    map((response: any) => response)
  );
